// @flow
import traverse from 'fc-utils/traverse'

export default traverse(['auth', 'isAuthenticated'], {
  default: false,
})
